const FILE_TYPES: { [fileType: string]: string } = {
    IMAGE: 'IMAGE',
    DOCUMENT: 'DOCUMENT',
    PDF: 'PDF',
    VIDEO: 'VIDEO',
    OTHER: 'OTHER'
};

enum BROWSERS {
    Firefox, Opera, IE, Edge, Chrome, Safari, Unknown
}

enum ACH_ACCOUNT_TYPE {
    PERSONAL_CHECKING_ACCOUNT = 'personal_checking_account',
    PERSONAL_SAVING_ACCOUNT = 'personal_saving_account',
    BUSINESS_CHECKING_ACCOUNT = 'business_checking_account',
    BUSINESS_SAVING_ACCOUNT = 'business_saving_account',
    CARDCONNECT_CHECKING_ACCOUNT = 'ECHK',
    CARDCONNECT_SAVING_ACCOUNT = 'ESAV',
}

const ACH_ACCOUNT_TYPE_NAMES: { [index: string]: string } = {};
ACH_ACCOUNT_TYPE_NAMES[ACH_ACCOUNT_TYPE.PERSONAL_CHECKING_ACCOUNT] = 'Personal Checking Account';
ACH_ACCOUNT_TYPE_NAMES[ACH_ACCOUNT_TYPE.PERSONAL_SAVING_ACCOUNT] = 'Personal Saving Account';
ACH_ACCOUNT_TYPE_NAMES[ACH_ACCOUNT_TYPE.BUSINESS_CHECKING_ACCOUNT] = 'Business Checking Account';
ACH_ACCOUNT_TYPE_NAMES[ACH_ACCOUNT_TYPE.BUSINESS_SAVING_ACCOUNT] = 'Business Saving Account';
ACH_ACCOUNT_TYPE_NAMES[ACH_ACCOUNT_TYPE.CARDCONNECT_CHECKING_ACCOUNT] = 'Checking Account';
ACH_ACCOUNT_TYPE_NAMES[ACH_ACCOUNT_TYPE.CARDCONNECT_SAVING_ACCOUNT] = 'Saving Account';

const NO_SELECTED_OPTION_TOAST_WARNING_TEXT = 'Please select an option to continue.';

enum RAINFOREST_PAYMENT_METHODS {
    CARD = 'CARD',
    ACH = 'ACH',
    VALIDATED_ACH = 'VALIDATED_ACH'
}

const REMOTE_PAYMENT_ERRORS = {
    CVV: 'Invalid CVV field',
    MM: 'Invalid Expiration Month',
    YY: 'Invalid Expiration Year',
    AMOUNT: 'Invalid Payment Amount',
    TOKEN: 'Invalid Credit Card Number',
    EXPIRATION: 'Invalid Expiration',
};

export const CONSTANTS = {
    SIGNATURE_CONTAINER_HEIGHT: 215,
    FILE_TYPES: FILE_TYPES,
    BROWSERS,
    ACH_ACCOUNT_TYPE,
    ACH_ACCOUNT_TYPE_NAMES,
    NO_SELECTED_OPTION_TOAST_WARNING_TEXT,
    RAINFOREST_PAYMENT_METHODS,
    REMOTE_PAYMENT_ERRORS
};
